import Gamepad, { Event } from "core/gamepad";
import SurveyKeyDownController from "./keydown";
import SurveyButttonPressedController from "./buttonpressed";
import SurveyAxisMoveController from "./axismove";
import Survey from "app/survey";
import Deferred from "core/deferred";
import { post } from "core/api";
export default function SurveyShowController(view) {
  return async ({
    currentPlayerIndex
  }) => {
    console.log("Survey show:", currentPlayerIndex);
    view.setPlayer(currentPlayerIndex);
    const model = {
      surveyDone: false,
      end: false,
      deferred: new Deferred()
    };
    const survey = Survey();
    const keyDownCtrl = SurveyKeyDownController(view, model);
    const buttonPressedCtrl = SurveyButttonPressedController(view, model);
    const axisMoveCtrl = SurveyAxisMoveController(view, model);
    Gamepad.on(Event.ButtonDown, buttonPressedCtrl);
    Gamepad.on(Event.Move, axisMoveCtrl);
    document.addEventListener("keydown", keyDownCtrl);
    try {
      await view.showIntro(survey.intro);
      const {
        answers
      } = await askQuestions();
      post("/feedback", answers);
      await view.showOutro(survey.outro);
      model.surveyDone = true;
      return "surveyDone";
    } catch (err) {
      model.surveyDone = true;
      if (err == "cancel") return "surveyDone";
      console.log(err);
    }
    Gamepad.off(Event.ButtonDown, buttonPressedCtrl);
    Gamepad.off(Event.Move, axisMoveCtrl);
    document.removeEventListener("keydown", keyDownCtrl);
    async function askQuestions() {
      while (survey.hasQuestion()) {
        const text = survey.getQuestion();
        const answer = survey.getAnswers();
        console.log("showing question", text);
        view.setProgress(survey.getCurrentIndex(), survey.getQuestionCount());
        const res = await view.askQuestion(text, answer);
        console.log("answer", res);
        survey.setAnswer(res);
        const followUp = survey.getFollowUp();
        if (followUp) {
          console.log("followUp", typeof followUp, res);
          if (typeof followUp == "object") {
            if (res in followUp) await view.showFollowUp(followUp[res]);
          } else {
            await view.showFollowUp(followUp);
          }
        }
        survey.gotoNextQuestion();
      }
      const answers = survey.getAllAnswers();
      return {
        answers
      };
    }
  };
}